import { render } from "./disconnected.vue?vue&type=template&id=2be86db2"
import script from "./disconnected.vue?vue&type=script&lang=js"
export * from "./disconnected.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__